import {
  DateTimeFormatter,
  Duration,
  Instant,
  LocalDate,
  LocalDateTime,
  LocalTime,
  Month,
  MonthDay,
  Year,
  YearMonth,
  ZoneId,
} from "@js-joda/core";

export interface OrdInternal {
  "fantasy-land/lte"(b: any): boolean;
  "fantasy-land/equals"(b: any): boolean;
}

export declare type Ord =
  | OrdInternal
  | number
  | string
  | Duration
  | Instant
  | LocalDate
  | LocalDateTime
  | LocalTime
  | MonthDay
  | YearMonth
  | Month
  | Year;

interface JodaOrd<T extends Duration> extends OrdInternal {
  v: T;
  "fantasy-land/lte"(b: T): boolean;
  "fantasy-land/equals"(b: T): boolean;
}

const formatterLocalDateTime = DateTimeFormatter.ofPattern("yyyy-MM-dd'T'HH:mm:ss.nnnnnnnnn");
const formatterLocalTime = DateTimeFormatter.ofPattern("HH:mm:ss.nnnnnnnnn");

export function toInternalOrd(x: Ord): OrdInternal | number | string {
  if (typeof x === "number") {
    return x;
  }
  if (typeof x === "string") {
    return x;
  }

  if (x instanceof Duration) {
    const o: JodaOrd<Duration> = {
      v: x,
      "fantasy-land/equals": (other: Duration): boolean => {
        return x.equals(other);
      },
      "fantasy-land/lte": (other: Duration): boolean => {
        return x.compareTo(other) <= 0;
      },
    };
    return o;
  }

  if (x instanceof Instant) {
    return LocalDateTime.ofInstant(x, ZoneId.UTC).format(formatterLocalDateTime);
  }
  if (x instanceof LocalDate) {
    return x.toString();
  }
  if (x instanceof LocalDateTime) {
    return x.format(formatterLocalDateTime);
  }
  if (x instanceof LocalTime) {
    return x.format(formatterLocalTime);
  }
  if (x instanceof MonthDay) {
    return x.toString();
  }
  if (x instanceof YearMonth) {
    return x.toString();
  }
  if (x instanceof Month) {
    return x.value();
  }
  if (x instanceof Year) {
    return x.value();
  }

  return x;
}
